import { render } from "./FixedNavbar.vue?vue&type=template&id=0871bd5a"
import script from "./FixedNavbar.vue?vue&type=script&lang=js"
export * from "./FixedNavbar.vue?vue&type=script&lang=js"

import "./FixedNavbar.vue?vue&type=style&index=0&id=0871bd5a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__